/**
 * useOldSeasonLabel — retorna la etiqueta del nº de abonado de la temporada anterior.
 * Útil en flujos de renovación donde se pide el número de la temporada que finalizó.
 *
 * La temporada anterior es siempre (añoActual - 1) / añoActual en formato corto.
 * Ejemplo: en 2026 → "nº abonado temporada 25/26"
 *
 * @returns {string}
 */
export function useOldSeasonLabel() {
    const year = new Date().getFullYear();
    const prev = String(year - 1).slice(-2);
    const curr = String(year).slice(-2);
    return `nº abonado temporada ${prev}/${curr}`;
}
